import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useDebounceFn, useWindowSize } from "@vueuse/core";

interface Emits {
  (e: "update:modelValue", value: number): void;
}
interface Props {
  tabs: { id: number; name: string }[];
  modelValue: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTabs',
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emits = __emit;

const { width } = useWindowSize();
const tabsListMaxWidth = ref<string>("100%");
const checkWindowWidth = useDebounceFn((newV) => {
  tabsListMaxWidth.value = `${newV - 32}px`;
}, 100);
watch(
  () => width.value,
  (newV) => {
    checkWindowWidth(newV);
  },
  { immediate: true }
);

const activeTabId = ref<number>(props.modelValue);
watch(
  () => props.modelValue,
  (newV) => {
    activeTabId.value = newV;
  },
  {
    immediate: true,
  }
);
watch(
  () => activeTabId.value,
  (newV) => {
    emits("update:modelValue", newV);
  },
  {
    immediate: true,
  }
);
const activeTabSlotName = computed<string>(() => `tab-${activeTabId.value}`);

const __returned__ = { props, emits, width, tabsListMaxWidth, checkWindowWidth, activeTabId, activeTabSlotName, computed, ref, watch, get useDebounceFn() { return useDebounceFn }, get useWindowSize() { return useWindowSize } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})